module.exports = __webpack_public_path__ + "media/images/lb/393-eaf3871a94909bdc3c33b6bb5c52d0e7.svg";